// TODO: Remove this and replace with clsx
import classNames from '@ui/lib/utils/classNames'
import { useTabSelectorStore } from '@ui/stores'

interface TabSelectorProps {
  className?: string
  setParams: () => void
}

export function TabSelector(props: TabSelectorProps) {
  const selectorCss = props.className ? props.className : 'justify-normal'

  const currentTab = useTabSelectorStore((state) => state.currentTab)
  const setCurrentTab = useTabSelectorStore((state) => state.setCurrentTab)
  const tabs = useTabSelectorStore((state) => state.tabs)

  return (
    <nav
      className={classNames(selectorCss, '-mb-px flex justify-normal')}
      aria-label="Tabs"
      data-testid={'tab-selector'}>
      {tabs.map((tab, index) => (
        <a
          key={index}
          onClick={() => {
            props.setParams()
            setCurrentTab(tab)
          }}
          className={classNames(
            currentTab && tab === currentTab
              ? 'cursor-pointer border-primary-500 text-black'
              : 'cursor-pointer border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
            'pl-5whitespace-nowrap border-b-2 px-1 px-2 py-1 text-sm font-medium'
          )}
          aria-current={tab ? 'page' : undefined}>
          {tab}
        </a>
      ))}
    </nav>
  )
}
